import { defineMessages } from 'react-intl';

export default defineMessages({
  bannerMessage: {
    id: 'bannerCookiePolicy.bannerMessage',
    defaultMessage:
      'Azimut Capital Management SGR S.p.A e Azimut Financial Insurance S.p.A, in qualità di contitolari del trattamento dei dati personali, non utilizza cookie di profilazione ma solo cookie tecnici ai fini del corretto funzionamento delle pagine di questo sito. Per vedere quali cookie utilizziamo, come disabilitarli e quali sono di terze parti visita la nostra pagina dedicata ',
    description: 'Banner Message',
  },
  bannerLink: {
    id: 'bannerCookiePolicy.bannerLink',
    defaultMessage: 'cliccando qui',
    description: 'Banner Link',
  },
});
